module.exports = __webpack_public_path__ + "img/tools1.40e69d9f.svg";